import {ComponentRegistry} from '../../components/component-registry';
import {DataApi} from '../../api/data-api/data-api';
import {AbstractGroup} from '../abstract-group';
import {NewsFilter, NewsSettings} from './filter';

/**
 * News picker.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class Picker extends AbstractGroup<NewsFilter, NewsSettings> {
  constructor(container: HTMLElement) {
    super(container);
    this.find();
    ComponentRegistry.add('news-picker', this);
  }

  /**
   * Finds picked news.
   */
  protected find(): void {
    DataApi.instance.newsEndpoint.find(this.settings, null)
      .then(response => {
        if (this.isResultEmpty(response)) {
          this.empty();
          return;
        }
        this.notEmpty();

        let html = '';
        let i = 0;
        for (const document of response.documents) {
          let template = require('../../handlebars/templates/news/item.handlebars');
          if (this.settings.layout === 1) {
            template = require('../../handlebars/templates/news/picker-item.handlebars');
          }
          html += template({
            document: document,
            isLast: i === response.documents.length - 1,
            iteration: i++
          });
        }
        this.update(html);

        this.emitter.emit('change', this);
      })
      .catch(e => {
        this.error(e);
      });
  }
}
